import React from "react";
import { Container, useTheme } from "@mui/material";
import PageContent from "../../components/layout/container/PageContent";
import LegalSection from "./LegalSection";

const PrivacyPolicy = () => {
    const theme = useTheme();

    return (
        <PageContent title="Política de Privacidade">
            <Container maxWidth="md" sx={{ marginTop: theme.spacing(10) }}>

                <LegalSection title="1. Introdução">
                    A Associação Desportiva e Cultural de Benavente valoriza a privacidade dos seus utilizadores e está comprometida em proteger as informações
                    pessoais recolhidas através do nosso website. Esta Política de Privacidade explica como recolhemos, utilizamos, divulgamos e protegemos as
                    suas informações pessoais.
                </LegalSection>

                <LegalSection title="2. Informações Recolhidas">
                    Recolhemos informações de várias formas, incluindo:
                    <ul>
                        <li>
                            Informações fornecidas diretamente: Nome, endereço de e-mail, número de telefone, data de nascimento,
                            e outras informações que os utilizadores possam fornecer voluntariamente.
                        </li>
                        <li>
                            Informações automáticas: Dados de navegação, como endereço IP, tipo de navegador, páginas visitadas e
                            tempo gasto no site, através de cookies e tecnologias semelhantes.
                        </li>
                    </ul>
                </LegalSection>

                <LegalSection title="3. Utilização das Informações">
                    Utilizamos as informações recolhidas para os seguintes fins:
                    <ul>
                        <li>Comunicação: Enviar newsletters, atualizações e outras comunicações relacionadas com a equipa.</li>
                        <li>Melhoria do Serviço: Analisar o comportamento dos utilizadores para melhorar a funcionalidade e a experiência do nosso website.</li>
                        <li>Marketing: Personalizar e melhorar as campanhas de marketing.</li>
                    </ul>
                </LegalSection>

                <LegalSection title="4. Partilha de Informações">
                    Não partilhamos as suas informações pessoais com terceiros, exceto as estritamente necessárias para a manutenção das bases de dados do nosso website, bem como 
                    quando necessário para cumprir obrigações legais ou proteger os nossos direitos.
                </LegalSection>

                <LegalSection title="5. Segurança das Informações">
                    Implementamos medidas de segurança adequadas para proteger as suas informações pessoais contra acesso, alteração, divulgação ou destruição não autorizada.
                </LegalSection>

                <LegalSection title="6. Direitos dos Utilizadores">
                    Os utilizadores têm o direito de:
                    <ul>
                        <li>Aceder: Solicitar uma cópia das suas informações pessoais que possuímos.</li>
                        <li>Retificação: Corrigir informações pessoais incorretas ou incompletas.</li>
                        <li>Eliminação: Pedir a eliminação das suas informações pessoais, salvo exceções legais.</li>
                    </ul>
                </LegalSection>

                <LegalSection title="7. Cookies">
                    Utilizamos cookies para melhorar a funcionalidade do nosso site e a experiência do utilizador.
                    Os utilizadores podem controlar e/ou eliminar cookies conforme desejarem através das configurações do navegador.
                </LegalSection>
                
                <LegalSection title="8. Alterações a esta Política">
                    Reservamo-nos o direito de atualizar esta Política de Privacidade a qualquer momento.
                    Quaisquer alterações serão publicadas nesta página com a data da última atualização.
                </LegalSection>
                
                <LegalSection title="9. Contacto">
                    Se tiver dúvidas ou preocupações sobre esta Política de Privacidade, por favor, contacte-nos através dos contactos fornecidos na página "Sobre Nós".
                </LegalSection>

                <LegalSection title="Última Atualização">
                    30 de Julho de 2024
                </LegalSection>

            </Container>
        </PageContent>
    );
}

export default PrivacyPolicy;
